"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundColorMap = void 0;
var ToggleButtonProps_1 = require("./ToggleButtonProps");
var styles = require("./ToggleButton.css");
exports.BackgroundColorMap = new Map([
    [ToggleButtonProps_1.BackGroundColor.BLACK, styles.blackBackground],
    [ToggleButtonProps_1.BackGroundColor.WHITE, styles.whiteBackground],
]);
//# sourceMappingURL=ToggelButtonMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/ToggleButton/ToggelButtonMaps.js
// module id = 1376
// module chunks = 8